import { Report } from 'graphql-api';
import { REPORT_STEPS, PAID_REPORT_STEPS } from 'constants/report-steps';
import { NavigateFunction } from 'react-router-dom';
import { reportCurrentStepPath } from 'utils/path';
import { updateReport } from 'api/reports';

const reportSteps = (paid: boolean): string[] => {
  return paid ? PAID_REPORT_STEPS : REPORT_STEPS;
};

export const navigateAndStoreNextStep = async (
  report: Report,
  currentStep: string,
  navigate: NavigateFunction
): Promise<void> => {
  const steps = reportSteps(report.paid ?? false);
  const currentStepIndex = steps.indexOf(currentStep);
  const nextStep = steps[currentStepIndex + 1];
  const updatedReport = await updateReport(report, { currentStep: nextStep });
  if (updatedReport != null) {
    const navigatePath = reportCurrentStepPath(updatedReport);
    if (navigatePath !== null) {
      navigate(navigatePath);
    }
  }
};

export const navigateAndStorePreviousStep = async (
  report: Report,
  currentStep: string,
  navigate: NavigateFunction
): Promise<void> => {
  const steps = reportSteps(report.paid ?? false);
  const currentStepIndex = steps.indexOf(currentStep);
  const previousStep = steps[currentStepIndex > 0 ? currentStepIndex - 1 : 0];
  const updatedReport = await updateReport(report, { currentStep: previousStep });
  if (updatedReport != null) {
    const navigatePath = reportCurrentStepPath(updatedReport);
    if (navigatePath !== null) {
      navigate(navigatePath);
    }
  }
};

export const navigateAndStoreStep = async (
  report: Report,
  newStep: string,
  navigate: NavigateFunction
): Promise<void> => {
  const updatedReport = await updateReport(report, { currentStep: newStep });
  if (updatedReport != null) {
    const navigatePath = reportCurrentStepPath(updatedReport);
    if (navigatePath !== null) {
      navigate(navigatePath);
    }
  }
};
